// GENERATED COPY — do not edit. Source of truth:
// apps/count/client/src/components/nsMenuData.js (sync: node scripts/sync-ns-menu.mjs)
// nsMenuData.js — the NetSuite-mode menu structure, extracted so Run can
// mirror the same nav. SOURCE OF TRUTH lives here (Count); Run holds a
// verbatim copy at apps/run/client/src/components/nsmode/nsMenuData.js kept in
// sync by scripts/sync-ns-menu.mjs — run it after editing this file.
const RUN = 'https://run.daydreamerconcepts.com'
const GROW = 'https://grow.daydreamerconcepts.com'

const MENUS = [
  {
    label: 'Transactions',
    groups: [
      {
        label: 'Bank',
        children: [
          { label: 'Write Checks', to: '/checks' },
          { label: 'Make Deposits', to: '/bank-deposits' },
          { label: 'Transfer Funds', to: '/bank-transfers' },
          { label: 'Use Credit Card', to: '/credit-card-charges' },
          { label: 'Reconcile Bank Statement', to: '/bank-reconciliation' },
          { label: 'Bank Feeds', to: '/bank-feeds' },
          { label: 'CC Expense Coding', to: '/cc-expenses' },
          { label: 'CC Admin Coder', to: '/cc-coder' },
        ],
      },
      {
        label: 'Purchases',
        children: [
          { label: 'Enter Purchase Orders', to: '/purchase-orders' },
          { label: 'Enter Purchase Order (Native)', href: `${RUN}/native-purchase-orders/new?ns=1`, app: 'Run' },
          { label: 'Enter Requisitions', to: '/purchase-requisitions' },
          { label: 'Blanket Purchase Orders', to: '/blanket-purchase-orders' },
          { label: 'Purchase Contracts', to: '/purchase-contracts' },
          { label: 'Receive Orders (Item Receipts)', to: '/item-receipts' },
          { label: 'Receive Order (Native)', href: `${RUN}/native-receipts/new?ns=1`, app: 'Run' },
          { label: 'Authorize Vendor Returns', to: '/vendor-return-authorizations' },
        ],
      },
      {
        label: 'Payables',
        children: [
          { label: 'Enter Bills', to: '/bills' },
          { label: 'Bill Capture (AP Inbox)', to: '/ap-capture' },
          { label: 'Pay Bills', to: '/bill-payments' },
          { label: 'Enter Vendor Credits', to: '/vendor-credits' },
          { label: 'Vendor Prepayments', to: '/vendor-prepayments' },
          { label: 'AP Aging', to: '/ap-aging' },
        ],
      },
      {
        label: 'Sales',
        children: [
          { label: 'Prepare Estimates', to: '/estimates' },
          { label: 'Enter Sales Orders', to: '/sales-orders' },
          { label: 'Enter Sales Order (Native)', href: `${RUN}/native-orders/new?ns=1`, app: 'Run' },
          { label: 'Create Invoices', to: '/invoices' },
          { label: 'Enter Cash Sales', to: '/cash-sales' },
          { label: 'Enter Opportunities', to: '/opportunities' },
          { label: 'Trade Show POS', href: `${GROW}/pos`, app: 'Grow' },
        ],
      },
      {
        label: 'Customers',
        children: [
          { label: 'Accept Customer Payments', to: '/customer-payments' },
          { label: 'Apply Payments', to: '/payment-application' },
          { label: 'Record Customer Deposits', to: '/customer-deposits' },
          { label: 'Deposit Applications', to: '/deposit-applications' },
          { label: 'Issue Credit Memos', to: '/credit-memos' },
          { label: 'Issue Customer Refunds', to: '/customer-refunds' },
          { label: 'Authorize Returns', to: '/return-authorizations' },
          { label: 'AR Aging', to: '/ar-aging' },
          { label: 'Faire Reconciliation', to: '/faire-reconciliation' },
        ],
      },
      {
        label: 'Order Management',
        children: [
          { label: 'Fulfill Orders (Item Fulfillments)', to: '/item-fulfillments' },
          { label: 'Fulfill Orders (Pack Station)', href: `${RUN}/pack-station?ns=1`, app: 'Run' },
          { label: 'Fulfill Order (Native)', href: `${RUN}/native-fulfillments/new?ns=1`, app: 'Run' },
          { label: 'Pick Tickets', href: `${RUN}/pick-tickets?ns=1`, app: 'Run' },
          { label: 'Sales Orders', to: '/sales-orders' },
          { label: 'Transfer Orders', to: '/transfer-orders' },
        ],
      },
      {
        label: 'Employees',
        children: [
          { label: 'Enter Expense Reports', to: '/expense-reports' },
          { label: 'Payroll Journal', to: '/payroll' },
        ],
      },
      {
        label: 'Inventory',
        children: [
          { label: 'Adjust Inventory', to: '/inventory-transactions' },
          { label: 'Adjust Inventory (Native)', href: `${RUN}/native-inventory-adjustments/new?ns=1`, app: 'Run' },
          { label: 'Transfer Inventory', to: '/inventory/transfers' },
          { label: 'Transfer Inventory (Native)', href: `${RUN}/native-transfers/new?ns=1`, app: 'Run' },
          { label: 'Cycle Counts', to: '/inventory/cycle-counts' },
          { label: 'Landed Cost', to: '/landed-cost' },
          { label: 'Inventory by Location', to: '/inventory/by-location' },
        ],
      },
      {
        label: 'Manufacturing',
        children: [
          { label: 'Enter Work Orders', href: `${RUN}/native-work-orders/new?ns=1`, app: 'Run' },
          { label: 'Work Orders', href: `${RUN}/workorders?ns=1`, app: 'Run' },
          { label: 'Build Assemblies', href: `${RUN}/native-assembly-builds/new?ns=1`, app: 'Run' },
          { label: 'Assembly Builds', href: `${RUN}/native-assembly-builds?ns=1`, app: 'Run' },
          { label: 'Production Schedule', href: `${RUN}/production/dashboard?ns=1`, app: 'Run' },
        ],
      },
      {
        label: 'Financial',
        children: [
          { label: 'Make Journal Entries', to: '/journal-entries/new' },
          { label: 'Journal Entries', to: '/journal-entries' },
          { label: 'Recurring Entries', to: '/recurring-entries' },
          { label: 'Intercompany Transfers', to: '/intercompany-transfers' },
          { label: 'Revenue Reclass', to: '/revenue-reclass' },
          { label: 'Exchange Rates', to: '/exchange-rates' },
        ],
      },
    ],
  },
  {
    label: 'Lists',
    groups: [
      {
        label: 'Relationships',
        children: [
          { label: 'Customers', to: '/customers' },
          { label: 'Customers — New', href: `${RUN}/records/customers/new?ns=1` },
          { label: 'Vendors', to: '/vendors' },
          { label: 'Vendors — New', href: `${RUN}/records/vendors/new?ns=1` },
        ],
      },
      {
        label: 'Accounting',
        children: [
          { label: 'Items', to: '/inventory' },
          { label: 'Chart of Accounts', to: '/accounts' },
          { label: 'Accounting Periods', to: '/periods' },
          { label: 'Subsidiaries (Entities)', to: '/entities' },
          { label: 'Departments', to: '/departments' },
          { label: 'Transaction Types', to: '/transaction-types' },
          { label: 'Fixed Assets', to: '/fixed-assets' },
        ],
      },
      {
        label: 'Supply Chain',
        children: [
          { label: 'Inventory Items', to: '/inventory' },
          { label: 'Locations & Bins', to: '/inventory/locations' },
        ],
      },
    ],
  },
  {
    label: 'Reports',
    groups: [
      {
        label: 'Financial',
        children: [
          { label: 'Balance Sheet', to: '/balance-sheet' },
          { label: 'Income Statement', to: '/income-statement' },
          { label: 'Cash Flow Statement', to: '/cash-flow' },
          { label: 'Trial Balance', to: '/trial-balance' },
          { label: 'Consolidated Reports', to: '/consolidated-reports' },
        ],
      },
      {
        label: 'Receivables / Payables',
        children: [
          { label: 'AR Aging', to: '/ar-aging' },
          { label: 'AP Aging', to: '/ap-aging' },
        ],
      },
      {
        label: 'Inventory',
        children: [
          { label: 'Inventory Valuation', to: '/inventory-valuation' },
          { label: 'Inventory by Location', to: '/inventory/by-location' },
        ],
      },
      {
        label: 'Management',
        children: [
          { label: 'Accounting Dashboard', to: '/accounting-dashboard' },
          { label: 'GL Impact Plan', to: '/gl-impact-plan' },
          { label: 'Cash Flow Dashboard', to: '/cash-flow-dashboard' },
          { label: 'Cash Forecast', to: '/cash-forecast' },
          { label: 'Budgets', to: '/budgets' },
          { label: 'P&L Forecast', to: '/subsidiary-forecast' },
        ],
      },
    ],
  },
  {
    label: 'Setup',
    groups: [
      {
        label: 'Sync & System',
        children: [
          { label: 'NetSuite Sync Status', to: '/netsuite-sync' },
          { label: 'Lockout Recovery', to: '/lockout-recovery' },
          { label: 'Operations Sync', to: '/operations-sync' },
          { label: 'Audit Log', to: '/audit-log' },
          { label: 'Approval Workflows', to: '/approval-workflows' },
          { label: 'User Roles', to: '/user-roles' },
          { label: 'Settings', to: '/settings' },
        ],
      },
    ],
  },
]

export { MENUS, RUN, GROW }
